import { render, staticRenderFns } from "./ProductOptionSwatches.vue?vue&type=template&id=346cc580&scoped=true&"
import script from "./ProductOptionSwatches.vue?vue&type=script&lang=js&"
export * from "./ProductOptionSwatches.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionSwatches.vue?vue&type=style&index=0&id=346cc580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346cc580",
  null
  
)

export default component.exports